import { ChangeDetectionStrategy, Component, computed } from "@angular/core";
import { RouterLink } from "@angular/router";
import { InteractiveFormComponent } from "../../components/interactive-form/interactive-form.component";
import { InteractiveFormSubmit } from "../../models/interactive-form.model";
import { toDuplicateFormValue } from "../../mappers/interactive.mapper";
import { injectRouteInteractive } from "../inject-route-interactive";
import { injectCreateInteractive } from "../inject-create-interactive";

@Component({
    selector: "app-duplicate-interactive",
    templateUrl: "./duplicate-interactive.component.html",
    styleUrl: "./duplicate-interactive.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterLink, InteractiveFormComponent]
})
export class DuplicateInteractiveComponent {
    private readonly createInteractive = injectCreateInteractive("We couldn’t duplicate this interactive. Try again.");
    readonly interactive = injectRouteInteractive();
    readonly submitting = this.createInteractive.submitting;

    readonly formValue = computed(() => {
        const interactive = this.interactive();
        return interactive ? toDuplicateFormValue(interactive) : null;
    });

    onSubmit(event: InteractiveFormSubmit): void {
        this.createInteractive.submit(event);
    }
}
